import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
const useStyles = makeStyles(theme => ({
    root: {
        height: 70,
        textAlign: "center",
        fontWeight: "normal",
        marginBottom: 28
    },
    title: {
        fontSize: "2rem"
    }
}));
const HeaderIcon = (props) => {
    const { icon, text } = props;
    const classes = useStyles();
    return (_jsxs("div", { className: classes.root, children: [icon && (_jsx(Typography, { children: _jsx("i", { className: `fa fa-5x fa-${icon} fa-fw` }) })), text && _jsx(Typography, { className: classes.title, children: text })] }));
};
HeaderIcon.displayName = "HeaderIcon";
export { HeaderIcon };
//# sourceMappingURL=HeaderIcon.js.map